<template>
  <div>
    <div class="topbar"><div class="brand" @click="$router.back()">&#8249; 我的推荐</div></div>
    <div class="content">
      <div class="reward-summary">
        <div><b>¥{{ yuan(summary.pendingAmount) }}</b><span>待结算</span></div>
        <div><b>¥{{ yuan(summary.availableAmount) }}</b><span>可结算</span></div>
        <div><b>¥{{ yuan(summary.pendingPayAmount) }}</b><span>待打款</span></div>
        <div><b>¥{{ yuan(summary.settledAmount) }}</b><span>已结算</span></div>
      </div>

      <div class="order-tabs">
        <div v-for="t in tabs" :key="t.key" class="order-tab" :class="{ active: currentTab === t.key }" @click="currentTab = t.key">
          {{ t.label }}<span class="tab-count" v-if="t.key !== 'all'">{{ counts[t.key] || 0 }}</span>
        </div>
      </div>

      <div v-if="!filtered.length" class="empty"><div class="empty-icon">🎁</div><div>该状态下暂无推荐奖励</div></div>
      <div v-for="r in filtered" :key="r.id" class="card">
        <div class="row">
          <div style="font-weight:600">{{ r.slotTitle }}</div>
          <span class="ref-status" :class="statusKey(r.rewardStatus)">{{ r.rewardStatusName }}</span>
        </div>
        <div class="muted" style="margin-top:6px">被推荐人：{{ r.buyerName || '--' }}（{{ r.buyerPhone || '--' }}）</div>
        <div class="muted">服务专家：{{ r.expertName || '--' }}</div>
        <div class="reward-money">
          <span>成交金额 ¥{{ yuan(r.paidAmount - (r.refundedAmount || 0)) }}</span>
          <b>奖励 ¥{{ yuan(r.rewardAmount) }}</b>
        </div>
        <div class="order-meta">
          <div>奖励比例：{{ percent(r.referralRate) }}</div>
          <div>支付时间：{{ r.paidTime }}</div>
          <div v-if="r.rewardStatus === 0">预计可结算：{{ r.availableTime }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { myReferralRewards, myReferralSummary } from "@/api/nrc.js";
const TABS = [
  { key: "all", label: "全部" }, { key: 0, label: "待结算" }, { key: 1, label: "可结算" },
  { key: 2, label: "待打款" }, { key: 3, label: "已结算" }, { key: 4, label: "已退费" },
];
export default {
  name: "MyReferrals",
  data() { return { rewards: [], summary: {}, currentTab: "all", tabs: TABS }; },
  computed: {
    counts() { let c = {}; this.rewards.forEach((r) => { c[r.rewardStatus] = (c[r.rewardStatus] || 0) + 1; }); return c; },
    filtered() { return this.currentTab === "all" ? this.rewards : this.rewards.filter((r) => r.rewardStatus === this.currentTab); },
  },
  created() {
    myReferralRewards().then((r) => (this.rewards = r));
    myReferralSummary().then((r) => (this.summary = r || {}));
  },
  methods: {
    yuan(v) { return ((v || 0) / 100).toFixed(2); },
    percent(v) { return `${((Number(v) || 0) * 100).toFixed(2).replace(/\.00$/, "")}%`; },
    statusKey(v) { return ["pending", "available", "paying", "settled", "refunded"][v] || "pending"; },
  },
};
</script>

<style scoped lang="scss">
.reward-summary { display:grid; grid-template-columns:1fr 1fr; gap:10px; margin-bottom:14px; }
.reward-summary div { padding:14px 8px; border-radius:10px; background:#fff; text-align:center; box-shadow:0 2px 8px rgba(0,0,0,.06); }
.reward-summary b { display:block; color:#0e7490; font-size:19px; }
.reward-summary span { color:#999; font-size:12px; }
.reward-money { display:flex; justify-content:space-between; margin:12px 0; padding-top:10px; border-top:1px solid #edf0f4; font-size:13px; }
.reward-money b { color:#e68a00; }
.ref-status { padding:3px 8px; border-radius:12px; font-size:12px; background:#eef4f7; color:#0e7490; }
.ref-status.refunded { color:#999; }.ref-status.settled { color:#29a36a; }.ref-status.paying { color:#e68a00; }
.order-tabs { overflow-x:auto; white-space:nowrap; }.order-tab { display:inline-block; }
</style>
